// extracted by mini-css-extract-plugin
module.exports = {"title":"WelcomeModal_title__1qib9","subtitle":"WelcomeModal_subtitle__3Lcc9","imgStyle":"WelcomeModal_imgStyle__3cKUc"};